// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_Ofi","cls2":"ProfileDropdown-cls2_Jw2 ProfileDropdown-cls1_Ofi"};